import { container, cid } from 'inversify-props';
import store, { IState } from '@/store';
import { Store } from 'vuex';
import VueRouter from 'vue-router';
import router from '@/router';
import {
  ICounterApi,
  CounterApi
} from '@/apis';
import {
  settingService,
  SettingService,
  axiosConfig,
  AxiosConfig,
  authService,
  AuthService,
  SyncService,
  ISyncService,
  SiteService,
  ISiteService,
  RouterService,
  IRouterService,
  MobileService,
  IMobileService,
  MealCountService,
  IMealCountService,
  MealCountStatusService,
  IMealCountStatusService,
  IMealLoader,
  MealLoader,
  countHub,
  CountHub} from '@/services';

container.bind<Store<IState>>(cid.IStore).toDynamicValue(() => store).inSingletonScope();
container.bind<VueRouter>(cid.IRouter).toDynamicValue(() => router).inSingletonScope();

container.bind<SettingService>(cid.ISettingService).toDynamicValue(() => settingService).inSingletonScope();
container.bind<AuthService>(cid.IAuthService).toDynamicValue(() => authService).inSingletonScope();
container.bind<AxiosConfig>(cid.IAxiosConfig).toDynamicValue(() => axiosConfig).inSingletonScope();

container.addSingleton<ISyncService>(SyncService);
container.addSingleton<ISiteService>(SiteService);
container.addSingleton<IRouterService>(RouterService);
container.addSingleton<IMobileService>(MobileService);

container.addSingleton<ICounterApi>(CounterApi);
container.addSingleton<IMealLoader>(MealLoader);
container.addSingleton<IMealCountService>(MealCountService);
container.addSingleton<IMealCountStatusService>(MealCountStatusService);

container.bind<CountHub>(cid.ICountHub).toDynamicValue(() => countHub).inSingletonScope();
